<template>
    <component
        :is="marketComponent"
        v-if="country"
        ref="market-component"
        v-model="address"
        :suggested-addresses-value="suggestedAddresses"
        class="market-component"
        :lang="lang"
        :include-email="includeEmail"
        :email-required="emailRequired"
        @blur="onBlur"
        @input="onInput"
        @new-address-in-form="onNewAddressInForm"
        @suggested-addresses-updated="onSuggestedAddressesUpdated"
    >
    </component>
</template>

<script>
import NsAddressAr from './address-ar/NsAddressAr.vue';
import NsAddressAt from './address-at/NsAddressAt.vue';
import NsAddressAu from './address-au/NsAddressAu.vue';
import NsAddressBe from './address-be/NsAddressBe.vue';
import NsAddressBn from './address-bn/NsAddressBn.vue';
import NsAddressCa from './address-ca/NsAddressCa.vue';
import NsAddressCh from './address-ch/NsAddressCh.vue';
import NsAddressCl from './address-cl/NsAddressCl.vue';
import NsAddressCo from './address-co/NsAddressCo.vue';
import NsAddressCz from './address-cz/NsAddressCz.vue';
import NsAddressDe from './address-de/NsAddressDe.vue';
import NsAddressDk from './address-dk/NsAddressDk.vue';
import NsAddressEs from './address-es/NsAddressEs.vue';
import NsAddressFi from './address-fi/NsAddressFi.vue';
import NsAddressFr from './address-fr/NsAddressFr.vue';
import NsAddressGb from './address-gb/NsAddressGb.vue';
import NsAddressHk from './address-hk/NsAddressHk.vue';
import NsAddressHu from './address-hu/NsAddressHu.vue';
import NsAddressId from './address-id/NsAddressId.vue';
import NsAddressIe from './address-ie/NsAddressIe.vue';
import NsAddressIl from './address-il/NsAddressIl.vue';
import NsAddressIs from './address-is/NsAddressIs.vue';
import NsAddressIt from './address-it/NsAddressIt.vue';
import NsAddressJp from './address-jp/NsAddressJp.vue';
import NsAddressLu from './address-lu/NsAddressLu.vue';
import NsAddressMx from './address-mx/NsAddressMx.vue';
import NsAddressMy from './address-my/NsAddressMy.vue';
import NsAddressNc from './address-nc/NsAddressNc.vue';
import NsAddressNl from './address-nl/NsAddressNl.vue';
import NsAddressNo from './address-no/NsAddressNo.vue';
import NsAddressNz from './address-nz/NsAddressNz.vue';
import NsAddressPe from './address-pe/NsAddressPe.vue';
import NsAddressPf from './address-pf/NsAddressPf.vue';
import NsAddressPh from './address-ph/NsAddressPh.vue';
import NsAddressPl from './address-pl/NsAddressPl.vue';
import NsAddressPt from './address-pt/NsAddressPt.vue';
import NsAddressRo from './address-ro/NsAddressRo.vue';
import NsAddressRu from './address-ru/NsAddressRu.vue';
import NsAddressSe from './address-se/NsAddressSe.vue';
import NsAddressSg from './address-sg/NsAddressSg.vue';
import NsAddressSk from './address-sk/NsAddressSk.vue';
import NsAddressTh from './address-th/NsAddressTh.vue';
import NsAddressTr from './address-tr/NsAddressTr.vue';
import NsAddressUa from './address-ua/NsAddressUa.vue';
import NsAddressUs from './address-us/NsAddressUs.vue';
import NsAddressVn from './address-vn/NsAddressVn.vue';
import NsAddressZa from './address-za/NsAddressZa.vue';

export default {
    name: 'NsAddress',
    components: {
        NsAddressAr,
        NsAddressAt,
        NsAddressAu,
        NsAddressBe,
        NsAddressBn,
        NsAddressCa,
        NsAddressCh,
        NsAddressCl,
        NsAddressCo,
        NsAddressCz,
        NsAddressDe,
        NsAddressDk,
        NsAddressEs,
        NsAddressFi,
        NsAddressFr,
        NsAddressGb,
        NsAddressHk,
        NsAddressHu,
        NsAddressId,
        NsAddressIe,
        NsAddressIl,
        NsAddressIs,
        NsAddressIt,
        NsAddressJp,
        NsAddressLu,
        NsAddressMx,
        NsAddressMy,
        NsAddressNc,
        NsAddressNl,
        NsAddressNo,
        NsAddressNz,
        NsAddressPe,
        NsAddressPf,
        NsAddressPh,
        NsAddressPl,
        NsAddressPt,
        NsAddressRo,
        NsAddressRu,
        NsAddressSe,
        NsAddressSg,
        NsAddressSk,
        NsAddressTh,
        NsAddressTr,
        NsAddressUa,
        NsAddressUs,
        NsAddressVn,
        NsAddressZa,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },

        lang: {
            type: String,
            required: true,
        },

        country: {
            type: String,
            required: true,
            validator(code) {
                return code.length === 2;
            },
        },

        includeEmail: {
            type: Boolean,
            default: false,
        },

        emailRequired: {
            type: Boolean,
            default: true, // not used if incluedEmail is false
        },
    },

    data() {
        return {
            addressVal: {},
            suggestedAddresses: [],
        };
    },

    computed: {
        marketComponent() {
            return `ns-address-${this.country.toLowerCase()}`;
        },
        address: {
            get() {
                return this.addressVal;
            },
            set(val) {
                this.addressVal = val;
            },
        },
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                this.address = this.value;
            },
        },

        country() {
            if (this.country !== this.address.country) {
                this.address = { country: this.country };
            }
        },
    },

    methods: {
        onInput() {
            this.$emit('input', this.address);
        },

        onNewAddressInForm() {
            this.$emit('new-address-in-form');
        },

        onBlur() {
            this.$emit('change', this.address);
        },

        onSuggestedAddressesUpdated(value) {
            this.suggestedAddresses = value;
        },
    },
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.addressHeaderWrapper {
  display: flex;
  justify-content: space-between;
  font-size: larger;
  font-weight: bold;

  .lnk {
    color: map.get(colors.$baseColors, shells);
    cursor: pointer;
    text-transform: uppercase;
  }
}

.addressButtons {
  margin-top: 15px;
}
.formSave {
  margin-bottom: 15px;
}

.nsAddressForm {
  .dateField {
    max-width: 120px;
  }

  h2 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
}

.hideElement {
  height: 0;
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/colors";

*:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, 'font-family-primary');
}
.market-component {
  ::v-deep {
    input[type='text']:focus {
      border: 1px solid map.get(colors.$theme, 'accent-color-b');
    }
  }
}
</style>

<style lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";

#mainContainer {
  a.v-list__tile,
  a.v-list__tile:hover,
  a.v-list__tile:active {
    align-content: center;
    color: inherit;
    display: flex;
    font-size: 16px;
    font-weight: 400;
    height: 48px;
    margin: 0;
    padding: 0 16px;
    position: relative;
    text-decoration: none;
    -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    text-transform: none;
  }
}
</style>
